export const WAY_OF_FISHING_OPTIONS = ["Shore", "Boat"];
const LURE_FISHING_TYPES = [
  "Spinning",
  "Boat Spinning",
  "Popping",
  "Fly Fishing",
  "Jigging",
];

function normalizeOptionLabel(value) {
  if (typeof value !== "string") {
    return "";
  }

  return value.trim().replace(/\s+/g, " ");
}

function buildNormalizedOptions(labels = []) {
  const seen = new Set();
  const options = [];

  labels.forEach((label) => {
    const normalizedLabel = normalizeOptionLabel(label);
    if (!normalizedLabel) {
      return;
    }

    const key = normalizedLabel.toLowerCase();
    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    options.push({ value: key, label: normalizedLabel });
  });

  return options;
}

export function getTypeOfFishingOptionsForWay(fishingMethods = {}, wayOfFishing = "") {
  const methods = fishingMethods?.[wayOfFishing];
  if (!methods || typeof methods !== "object") {
    return [];
  }

  return Object.keys(methods)
    .map((value) => normalizeOptionLabel(value))
    .filter(Boolean);
}

export function isLureFishingType(typeOfFishing = "") {
  if (typeof typeOfFishing !== "string" || !typeOfFishing.trim()) {
    return false;
  }

  return LURE_FISHING_TYPES.some((typeLabel) =>
    typeOfFishing.toLowerCase().includes(typeLabel.toLowerCase())
  );
}

export function buildWayOfFishingFilterOptions(additionalLabels = []) {
  return buildNormalizedOptions([...WAY_OF_FISHING_OPTIONS, ...additionalLabels]);
}

export function buildTypeOfFishingFilterOptions(
  fishingMethods = {},
  additionalLabels = []
) {
  const sourceLabels = WAY_OF_FISHING_OPTIONS.flatMap((wayOfFishing) =>
    getTypeOfFishingOptionsForWay(fishingMethods, wayOfFishing)
  );

  return buildNormalizedOptions([...sourceLabels, ...additionalLabels]);
}

export function buildFishSpeciesSuggestions(fishList = [], query = "", limit = 8) {
  const normalizedQuery = normalizeOptionLabel(query).toLowerCase();
  if (!normalizedQuery || !Array.isArray(fishList)) {
    return [];
  }

  return fishList
    .filter((fish) => {
      const commonName =
        typeof fish?.commonName === "string" ? fish.commonName.toLowerCase() : "";
      const scientificName =
        typeof fish?.scientificName === "string"
          ? fish.scientificName.toLowerCase()
          : "";

      return (
        commonName.includes(normalizedQuery) ||
        scientificName.includes(normalizedQuery)
      );
    })
    .slice(0, limit);
}

export function buildFishSpeciesFilterOptions(fishList = [], additionalLabels = []) {
  const sourceLabels = Array.isArray(fishList)
    ? fishList
        .map((fish) => normalizeOptionLabel(fish?.commonName || ""))
        .filter(Boolean)
    : [];

  return buildNormalizedOptions([...sourceLabels, ...additionalLabels]);
}
